import { useGoogleAuth } from 'front-end/src/app/hooks/useGoogleAuth'
import {
  ButtonClean,
  ButtonPrimary,
  Modal,
  Text
} from 'front-end/src/components'
import { t, Trans } from '@lingui/macro'
import React from 'react'

export const PublishGoogleCalendarSyncModal = ({ resolve, reject }) => {
  const { isAuthenticated, authenticate } = useGoogleAuth()

  return (
    <Modal
      newDesign
      header={t`Connect to Google Calendar`}
      controls={
        <>
          <ButtonClean onClick={reject}>
            <Trans>Cancel</Trans>
          </ButtonClean>
          <ButtonPrimary
            onClick={async () => {
              if (!isAuthenticated) {
                const authenticated = await authenticate()
                if (authenticated) {
                  resolve()
                }
              } else {
                resolve()
              }
            }}
          >
            <Trans>Confirm</Trans>
          </ButtonPrimary>
        </>
      }
      onHide={reject}
    >
      <Text>
        <Trans>
          In order to sync this and other events with Google Calendar, Looop
          requires your permission to access your calendar.
        </Trans>
      </Text>
      <Text>
        <Trans>You can manage this in your profile.</Trans>
      </Text>
    </Modal>
  )
}
